module.exports = __webpack_public_path__ + "static/media/064-music note.b313fc36.svg";